<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="t_name">
    <p class="cn">目录</p>
    <p class="en">contents</p>
  </div>
  <p class="detail">
    本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
    {{ taskSum }} 份。
  </p>
  <div
    class="item"
    v-for="({ title, child, num }, index) in catalogue"
    :key="index"
  >
    <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
    <div>
      <p>{{ title }}</p>
      <div class="child" v-if="Array.isArray(child)">
        <p v-for="({ title }, childIndex) in child" :key="childIndex">
          {{ title }}
        </p>
        <p v-if="child.length == 1">
          {{ `${num}`.padStart(2, '0') }}
        </p>
        <p v-else>
          {{
            [child[0].num, child.slice(-1)[0].num]
              .map(num => `${num}`.padStart(2, '0'))
              .join('-')
          }}
        </p>
      </div>
    </div>
  </div>
  <div class="global_hr"></div>
</template>

<script setup lang="tsx">
import { watch, withDefaults, defineProps, defineEmits } from 'vue';

type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
.catalogue {
  position: relative;
}
.t_name {
  width: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: var(--custom-page-top);
  left: 0;
  .cn {
    font-size: 106px;
    font-weight: 500;
    color: var(--theme-color-1);
  }
  .en {
    font-size: 200px;
    font-weight: 500;
    -webkit-text-stroke: 1pt #9f9f9f;
    color: transparent;
    writing-mode: vertical-lr;
    text-transform: uppercase;
  }
}
.detail {
  font-size: 16px;
  font-weight: 500;
  line-height: 36px;
  color: #3e3e3e;
  padding-top: 28px;
  padding-bottom: 72px;
}
.global_hr {
  position: absolute;
  width: 60%;
  height: 10px;
  left: 40%;
  bottom: var(--catalogue-page-bottom);
  background-color: var(--theme-color-1);
}

.item {
  padding-top: 20px;
  padding-bottom: 60px;
  border-top: 2px solid #0f0f0f;
  display: flex;
  justify-content: space-between;
  text-align: right;
  .index {
    font-size: 77px;
    line-height: 1;
    color: var(--theme-color-1);
  }
  p {
    font-size: 30px;
    font-weight: 500;
    line-height: 1.4;
    color: #222222;
  }
  .child {
    p {
      font-size: 18px;
      line-height: 1.6;
      color: #777777;
    }
  }
}
</style>
